import { HeaderCellStyled } from './styled';
export const DEFAULT_LANG = 'en';
export const NAME_KEY = 'name';
const VALUE_KEY = 'value';
export const SPECIFICATION_KEY = 'specifications';
export const LOCALIZATION_VALUE_KEY = 'localizedValue';
export const TEXT_VALUE_KEY = 'textValue';
export const INDEX_PROP = 'index';
export const KEY_PROP = 'key';
export const VALUES_REMAP = {
    false: 'No',
    true: 'Yes',
};
export const TABLE_COLUMNS_CONFIG = [
    {
        id: NAME_KEY,
        cellWidth: {
            md: '204px',
            lg: '256px',
        },
        cell: HeaderCellStyled,
    },
    {
        id: VALUE_KEY,
    },
];
// Sort options
export const ASC = 'asc'; // ascending (a->b)
